{/* Technical draft — must be reviewed by a legal professional before going live. */}

export function DatenschutzPage() {
  return (
    <div className="max-w-3xl mx-auto py-12">
      <h1 className="text-2xl font-serif mb-6">Datenschutzerklärung</h1>

      <div className="prose prose-sm max-w-none text-text-secondary space-y-6">
        <p>
          Diese Datenschutzerklärung erläutert den Umfang und die Zwecke der Verarbeitung
          personenbezogener Daten im Zusammenhang mit der Nutzung der Patent-Auktionsplattform.
        </p>

        <section>
          <h2 className="font-serif text-xl mb-2">1. Verantwortlicher</h2>
          <p>Dr. Eugen Funk</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">2. Erhobene Daten und Zwecke</h2>
          <p><strong>Registrierungsdaten:</strong> Name, Unternehmensdaten, E-Mail, Telefonnummer — zur Identifikation und Kommunikation.</p>
          <p><strong>KYC-Dokumente:</strong> Handelsregisterauszugs, ggf. Ausweiskopien — zur Verifikation gem. GwG.</p>
          <p><strong>Gebotsdaten:</strong> Gebotshöhe, Zeitstempel, IP-Adresse, User-Agent — zur Auktionsdurchführung und Missbrauchserkennung.</p>
          <p><strong>Page-View- und Section-Focus-Analytics:</strong> IP-Adresse, besuchte Auktionen, Verweildauer pro Abschnitt — zur Plattformoptimierung und Missbrauchserkennung (Art. 6 Abs. 1 lit. f DSGVO).</p>
          <p><strong>Inquiries:</strong> Fragen zu Patenten, Absenderdaten — zur direkten Kommunikation zwischen Patentinhaber und Bieter.</p>
          <p><strong>Server-Logs:</strong> Automatisch durch Supabase generiert.</p>
          <p><strong>Cookies:</strong> ausschließlich technisch notwendige Session-Cookies.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">3. Rechtsgrundlagen</h2>
          <p>Art. 6 Abs. 1 lit. b DSGVO: Vertragserfüllung (Auktionsabwicklung).</p>
          <p>Art. 6 Abs. 1 lit. c DSGVO: Gesetzliche Pflichten (GwG, HGB).</p>
          <p>Art. 6 Abs. 1 lit. f DSGVO: Berechtigtes Interesse an Plattformbetrieb, Sicherheit und Optimierung.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">4. Empfänger der Daten</h2>
          <p>Supabase (EU-Region Frankfurt), Netlify (CDN), SMTP-Provider.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">5. Speicherdauer</h2>
          <p>Audit-Logs: 10 Jahre. | Analytics: 12 Monate, dann IP-Anonymisierung.</p>
          <p>Inquiries: 3 Jahre. | Gebotsdaten: Vertragsdauer + gesetzliche Aufbewahrung.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">6. Betroffenenrechte</h2>
          <p>Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
          Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21).
          Beschwerderecht bei der Berliner Beauftragten fur Datenschutz.</p>
        </section>

        <section>
          <h2 className="font-serif text-xl mb-2">7. Cookies</h2>
          <p>Die Webseite verwendet ausschließlich technisch notwendige Cookies (Session-Cookies).</p>
        </section>
      </div>
    </div>
  );
}
